import React from "react";

import { Box, Paper } from "@mui/material";

const PageLayout = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#eee",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{
          backgroundColor: "#FFFFFF",
          width: { lg: 900, xl: 1200 },
          padding: 10,
        }}
      >
        {children}
      </Paper>
    </Box>
  );
};

export default PageLayout;
